'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true,
})
exports.TextBlock = exports.PrintableTextBlock = void 0

var _react = _interopRequireDefault(require('react'))

var _styledComponents = _interopRequireDefault(require('styled-components'))

var _templateObject

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0)
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }))
}

var TextBlock = function TextBlock(_ref) {
  var html = _ref.html,
    inputClassName = _ref.inputClassName
  return /*#__PURE__*/ _react['default'].createElement('div', {
    className: inputClassName,
    dangerouslySetInnerHTML: {
      __html: html,
    },
  })
}

exports.TextBlock = TextBlock

var PrintableTextBlock = function PrintableTextBlock(_ref2) {
  var html = _ref2.html
  return /*#__PURE__*/ _react['default'].createElement(StyledDiv, {
    dangerouslySetInnerHTML: {
      __html: html,
    },
  })
}

exports.PrintableTextBlock = PrintableTextBlock

var StyledDiv = _styledComponents['default'].div(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteral([
      '\n  margin-top: 16px;\n  margin-bottom: 8px;\n  width: 100%;\n\n  h1 {\n    font-size: 18px;\n    margin-bottom: 4px;\n  }\n  h2 {\n    font-size: 16px;\n    margin-bottom: 4px;\n  }\n  h3 {\n    font-size: 14px;\n    margin-bottom: 4px;\n  }\n  h4 {\n    font-size: 12px;\n    margin-bottom: 4px;\n  }\n  p {\n    font-size: 14px;\n    margin-bottom: 4px;\n  }\n',
    ]))
)
